function text(value) {
  return String(value || '').trim();
}

function canonicalUtcNow() {
  return new Date().toISOString().replace(/(\.\d{3})Z$/, '$1000Z');
}

function submissionKey() {
  const uuid = globalThis.crypto?.randomUUID?.();
  return text(uuid) || `action-input-${Date.now().toString(36)}`;
}

const SUBMISSION_IDENTITY_KEYS = [
  'run_id',
  'workflow_job_id',
  'plan_id',
  'step_id',
  'action_id',
  'action_key',
  'interaction_id',
  'workflow_input_snapshot_id',
];

function submissionIdentity(request) {
  return Object.fromEntries(
    SUBMISSION_IDENTITY_KEYS.map((key) => [key, text(request?.[key])]),
  );
}

function submissionContextIsValid({ identity, values, submittedBy, idempotencyKey, revision }) {
  return (
    Object.values(identity).every(Boolean)
    && Array.isArray(values) && values.length > 0
    && values.every((item) => text(item.field_key) && Object.hasOwn(item, 'value'))
    && Boolean(text(submittedBy))
    && Boolean(text(idempotencyKey))
    && Number.isInteger(revision)
  );
}

/**
 * @param {{ request?: Record<string, unknown>, values?: Array<{field_key: string, value: unknown}>, submittedBy?: string, idempotencyKey?: string, submittedAt?: string }} [input]
 * @returns {import('./contracts').WorkflowInputSubmission | null}
 */
export function buildActionInputSubmission({
  request,
  values,
  submittedBy,
  idempotencyKey = submissionKey(),
  submittedAt = canonicalUtcNow(),
} = {}) {
  const identity = submissionIdentity(request);
  const revision = Number(request?.checkpoint_revision);
  if (!submissionContextIsValid({
    identity, values, submittedBy, idempotencyKey, revision,
  })) {
    return null;
  }
  return {
    schema_version: 1,
    idempotency_key: text(idempotencyKey),
    ...identity,
    expected_checkpoint_revision: revision,
    values: structuredClone(values),
    submitted_by: text(submittedBy),
    submitted_at: text(submittedAt),
  };
}

export default buildActionInputSubmission;
